<template>
  <div id="menber_order" class="menber_control menber_nav padding-30">
    <TabBar :list="tabList" :active="tabActive" @active="active"/>
    <div class="b_cont">
      <form id="goto-pay" action="http://www.jihui88.com/rest/pay/todo" method="post" style="display:none;">
        <input type="hidden" name="paymentConfigId" v-model="paymentConfigId" value=""/>
        <input type="hidden" name="url" v-model="url" value=""/>
        <input type="hidden" name="orderId" v-model="orderId" value=""/>
        <input type="submit" value="确认支付">
      </form>
      <div :class="'order_list active_bg order_' + tabActive">
        <ul>
          <li class="m-b-15" v-for="(item, inde) in list"
          :class="{'move_bg': item.showBg, 'm_receiving': item.paymentStatus!=='unpaid' && (item.shippingStatus==='unshipped' || item.shippingStatus==='shipped'), 'm_close': item.orderStatus==='invalid'}"
          :data-id="inde" @mouseout="item.showBg = false" @mouseover="item.showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-8">
                <div class="order_title" v-if="item.orderStatus==='invalid'">已关闭</div>
                <div class="order_title" v-else-if="item.paymentStatus==='unpaid'">待支付</div>
                <div class="order_title" v-else-if="item.shippingStatus==='unshipped'">待发货</div>
                <div class="order_title" v-else-if="item.shippingStatus==='shipped'">待收货</div>
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-12">订单号 : {{item.orderSn}}</span>
                  <span class="cont2 col-xs-12 col-sm-12">{{item.addTime}}</span>
                  <span class="cont3 col-xs-12 col-sm-12">支付方式：{{item.paymentConfigName}}</span>
                  <span class="cont4 col-xs-12 col-sm-12" v-if="item.shippingSet[0] && item.shippingStatus==='shipped'">物流编号/图片 :
                    <span v-if="item.shippingSet[0].deliverySn.indexOf('upload') > -1  ">
                      <img :src="$store.state.imgHost + item.shippingSet[0].deliverySn " @error="setErrorImg" @click="showPic"/>
                    </span>
                    <span v-else>{{item.shippingSet[0].deliverySn}}</span>
                  </span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 text_right">
                <div class="order_title">订单金额：</div>
                <div class="order_cont"><span class="cont1">￥{{item.totalAmount}}RMB</span></div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-8 m-b-15 order_info" v-for="(pro, pIndex) in item.orderItemSet">
                <a href="javascript:;" class="pic">
                  <img :src="pro.product.picUrl4" @error="setErrorImg" @click="showPic" width="80" height="80" border="0" />
                </a>
                <div class="text_h1">
                  <p class="m-b-5"><a href="javascript:;">{{pro.productName}} {{pro.productAttr}}</a></p>
                  <p>￥{{pro.productPrice}}RMB x {{pro.productQuantity}}</p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 m-b-15 order_btn">
                <a :href="'#/order/' + item.orderId" class="order_detail">订单详情</a>
                <a href="javascript:;" class="order_pay" v-on:click="toPay(item)" v-if="item.paymentStatus==='unpaid'&&item.orderStatus !=='invalid'">立即付款</a>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="list.length>0">
          <Pagination :page="page" :pageSize="pageSize" :count="count" @change-page="changePage"/>
        </div>
        <div v-else style="text-align: center;padding:10px;color: #999;">
          {{text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar'
import Pagination from '@/components/Pagination'
export default {
  components: {
    TabBar,
    Pagination
  },
  data () {
    return {
      tabList: [
        {name: '全部订单', ostate: 'initorderId'},
        {name: '待支付', ostate: '01'},
        {name: '待发货', ostate: '02'},
        {name: '已收货', ostate: '03'}
      ],
      tabActive: 0,
      // 数据
      list: [],
      listTest: [
        {
          orderId: '8a9e457e608d146001609222bf4e010e',
          orderSn: '20171226091157',
          addTime: '2017-12-26 17:23:58',
          paymentConfigName: '微信支付',
          totalAmount: 0.01,
          shippingStatus: 'unshipped',
          orderItemSet: [
            {
              product: {
                picPath: '/upload/j/j2/jihui88/picture/2017/06/28/8765af0d-1f3d-43df-bebe-7dbf8ab1b89c_4.jpg'
              },
              productAttr: '颜色:黑色;尺码:39;',
              productQuantity: 1,
              productName: '产品名称12',
              productPrice: 0.01
            }
          ],
          shippingSet: [],
          showBg: false
        }
      ],
      page: 1,
      pageSize: 10,
      count: 11,
      // other
      paymentConfigId: '',
      url: '',
      orderId: '',
      text: '加载中...'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$route.params.active) {
        vm.tabActive = vm.$route.params.active
      }
    })
  },
  created () {
    this.get()
  },
  methods: {
    active (index) {
      this.tabActive = index
      this.tabOstate = this.tabList[index].ostate
      this.page = 1
      this.get()
    },
    get () {
      var ctx = this
      this.$parent.$refs.loading && this.$parent.$refs.loading.show()
      window.$.ajax({
        url: '/rest/api/shop/order/list',
        data: {
          page: this.page,
          pageSize: this.pageSize,
          ostate: this.tabOstate
        },
        success (res) {
          ctx.$parent.$refs.loading && ctx.$parent.$refs.loading.hide()
          if (res.success) {
            var data = res.attributes.data
            data.forEach((item, index, arr) => {
              item.showBg = false
            })
            ctx.list = data
            ctx.count = res.attributes.count
            if (ctx.list.length === 0) {
              ctx.text = '暂无数据'
            } else {
              ctx.text = '加载中...'
            }
          } else {
            // window.alert(res.msg)
          }
        }
      })
    },
    changePage (page) {
      this.page = page
      this.list = []
      this.get()
    },
    toPay (item) {
      var _this = this
      window.$.ajax({
        url: 'http://www.jihui88.com/rest/api/shop/order/detail/' + item.orderId,
        success (res) {
          var paymentConfig = res.attributes.data.paymentConfig
          if (!paymentConfig) {
            window.alert('交易已关闭')
            return
          }
          _this.paymentConfigId = paymentConfig.paymentId
          _this.orderId = res.attributes.data.orderId
          window.ua = navigator.userAgent.toLowerCase()
          if (window.ua.match(/MicroMessenger/i)) {
            let orderPay = {
              orderId: _this.orderId,
              paymentConfigId: _this.paymentConfigId
            }
            window.parent.postMessage({ orderPay: orderPay }, '*')
          } else {
            window.$('#menber_order input[name=paymentConfigId]').val(_this.paymentConfigId)
            window.$('#menber_order input[name=orderId]').val(_this.orderId)
            window.$('#goto-pay').submit()
          }
        }
      })
    },
    setErrorImg (e) {
      e.target.src = 'static/images/pic.jpg'
    },
    showPic (e) {
      this.$parent.$refs.pic.show(e.target.src)
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Order.vue